import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SmartGridFeatureValues } from '@vi-iot/client/index';

@Pipe({
  name: 'dryContactSmartGrid',
  standalone: true,
})
export class DryContactSmartGridPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string): string {
    switch (value) {
      case SmartGridFeatureValues.forcedOperation:
        return this.translateService.instant(
          '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.FORCED_OPERATION'
        );
      case SmartGridFeatureValues.normalOperation:
        return this.translateService.instant(
          '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.NORMAL_OPERATION'
        );
      case SmartGridFeatureValues.off:
        return this.translateService.instant('+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.OFF');
      case SmartGridFeatureValues.recommendedOperation:
        return this.translateService.instant(
          '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.RECOMMENDED_OPERATION'
        );
      default:
        return '';
    }
  }
}
